
        var result = require("!!../../../../node_modules/css-loader/index.js!./member-discount-list.component.css");

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    


//////////////////
// WEBPACK FOOTER
// ./ClientApp/app/components/member-discount-list/member-discount-list.component.css
// module id = 607
// module chunks = 0